import { DownloadLinkEnh } from "../../../../../components/common/DownloadLink/DownloadLinkEnh";
import moment from "moment";

export default function RevisiMahasiswaCol({ revisiMahasiswa }) {
  return revisiMahasiswa ? (
    <div className="flex flex-col gap-2 p-2">
      <div className="flex flex-row rounded-md border border-slate-300">
        <div className="flex-none w-32 py-1 px-2 font-bold bg-slate-300">
          Berkas Manuskrip Revisi
        </div>
        <div className="py-1 px-2 flex-1">
          <DownloadLinkEnh
            endpoint={`/file/berkas/get/${revisiMahasiswa.nama_berkas_revisi}/`}
            label="Unduh"
          />
        </div>
      </div>
      <div className="flex flex-row items-center rounded-md border border-slate-300">
        <div className="flex-none w-32 py-1 px-2 font-bold bg-slate-300">
          Catatan Revisi
        </div>
        <div className="py-1 px-2 flex-1">
          <DownloadLinkEnh
            endpoint={`/file/berkas/get/${revisiMahasiswa.nama_berkas_catatan}/`}
            label="Unduh"
          />
        </div>
      </div>
      <div className="flex flex-row items-center rounded-md border border-slate-300">
        <div className="flex-none w-32 py-1 px-2 font-bold bg-slate-300">
          Diunggah pada
        </div>
        <div className="py-1 px-2 flex-1">
          {moment(revisiMahasiswa.timestamp).format("ddd, DD MMM YYYY, HH:mm")}
        </div>
      </div>
    </div>
  ) : (
    <div className="text-center font-bold">
      Mahasiswa belum mengumpulkan revisi!
    </div>
  );
}
